import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { SharedModule } from '../shared/shared.module';
import { WebpayModalComponent } from './webpay-modal.component';
import { WebpayPrintContractComponent } from './webpay-print-contract/webpay-print-contract.component';

@NgModule({
  declarations: [WebpayPrintContractComponent, WebpayModalComponent],
  imports: [
    SharedModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
  ],
  exports: [WebpayModalComponent],
})
export class WebpayModalModule {}
